import debug from 'debug';
import ComponentStorage from 'Global/Shared/Components/ComponentStorage/ComponentStorage';

const log = debug('LogService');

export class LogService {
	constructor() {
		this.settings = {};
		this.dataloggerUrl = location.origin;
		this.time = Date.now();
		this.timeOut = 1200000; // 20 minutes in ms (1000 * 60 * 20 = 1.200.000)
		this.reloadSessionKey = 'reloadSession';

		this.componentStorage = new ComponentStorage({ componentKey: this.constructor.name });

		this.SessionTimeOut();
	}

	// Returns the name of the calling function (taken from stacktrace)
	CallerName(stackTrace) {
		let callerName = stackTrace.replace(/^Error\s+/, ''); // Sanitize Chrome

		callerName = callerName.split("\n")[1]; // 1st item is this, 2nd item is caller
		callerName = callerName.replace(/^\s+at Object./, ''); // Sanitize Chrome
		callerName = callerName.replace(/ \(.+\)$/, ''); // Sanitize Chrome
		callerName = callerName.replace(/\@.+/, ''); // Sanitize Firefox

		return callerName.trim();
	}

	// Merges two JavaScript objects
	Extend(obj, src) {
		Object.keys(src).forEach(function(key) { obj[key] = src[key]; });
		return obj;
	}

	GetReloadSessionKey() {
		return this.reloadSessionKey;
	}

	// Checks if option properties excist
	HasOptions(options, params) {
		let valid = true;
		let missingParams = [];

		if (!options) {
			let stackTrace = (new Error()).stack;

			log(`ERROR - "${ this.CallerName(stackTrace) }" has no params`);
			return false;
		}
		
		params.map(param => {
			if (!options.hasOwnProperty(param)) {
				valid = false;
				missingParams.push(param);
			}
		})

		if (valid) return true;

		let stackTrace = (new Error()).stack;
		
		log(`ERROR - "${ this.CallerName(stackTrace) }" missing params: ${ missingParams }`);
		throw new Error(`"${ this.CallerName(stackTrace) }" missing params [${ missingParams }]`);
		return false;
	}

	/**
	 * There are currently no new features toggled by Launch Darkly
	 * 
	 * @returns {Promise} allways resolve
	 */
	LaunchDarklyFeature() {
		return new Promise((resolve, reject) => {
			this.settings = this.Settings();
			resolve();
		});
	}

	/**
	 * @param {Object} options
	 * @param {string} options.url
	 * @param {Object} options.body
	 * @param {Boolean} options.triggerLoggingOnReload
	 */
	Post(options) {
		if (options.triggerLoggingOnReload === undefined) {
			options.triggerLoggingOnReload = true;
		}

		const endpoint = this.dataloggerUrl + options.url;
		log('Post() - url', endpoint);
		log('Post() - body (json, string)', options.body, JSON.stringify(options.body));

		if (this.VerifySessionTimeOut(options)) return;

		fetch(endpoint, {
			method: 'post',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(options.body)
		}).then(response => {
			log('Post() - response', options.url, response);
			if (response.status === 400) return response.text();
		}).then(text => {
			if (text) log('Post() - text', text);
		}).catch(error => {
			log('Post() - error', options.url, error);
		});
	}

	SessionTimeOut() {
		let sessionData = JSON.parse(this.componentStorage.getItem(this.reloadSessionKey));
		log('SessionTimeOut()', sessionData);

		if (sessionData === null || sessionData.reload !== true) return;
		if (!sessionData.triggerLoggingOnReload) return;
		
		this.componentStorage.removeItem(this.reloadSessionKey);

		this.settings = this.Settings();
		log('SessionTimeOut() - settings, sessionData', this.settings, sessionData);

		sessionData.body.sessionID = this.settings.sessionID;

		this.Post({
			url: sessionData.url,
			body: sessionData.body,
			triggerLoggingOnReload: sessionData.triggerLoggingOnReload
		})
	}

	Settings() {
		let settings = {};
		let dataCloudApi;
		let dataSettings;

		try {
			dataCloudApi = JSON.parse(document.body.getAttribute('data-cloudapi'));
			if (!dataCloudApi || !dataCloudApi.cloudDataLoggerUrl) {
				log('Cloud Data Logger API settings is not set in BODY');
			}
		}
		catch(error) {
			log('Settings() - Cloud Data Logger API', error);
		}

		try {
			dataSettings = JSON.parse(document.body.getAttribute('data-settings'));
			if (!dataSettings || !dataSettings.sessionId) {
				log('Settings is not set in BODY');
			}
		}
		catch(error) {
			log('Settings() - sessionId', error);
		}

		settings.sessionID = dataSettings.sessionId;
		log('Settings()', settings);

		this.dataloggerUrl = '//' + dataCloudApi.cloudDataLoggerUrl;

		return settings;
	}

	/**
	 * @param {Object} options 
	 * @param {string} options.url 
	 * @param {Object} options.body 
	 * @param {Boolean} options.triggerLoggingOnReload
	 */
	VerifySessionTimeOut(options) {
		log('VerifySessionTimeOut()', this.time, this.timeOut);

		const timeDif = Date.now() - this.time;

		if (timeDif > this.timeOut && typeof options === 'object') {
			this.componentStorage.setItem(this.reloadSessionKey, JSON.stringify({
				reload: true,
				url: options.url,
				body: options.body,
				triggerLoggingOnReload: options.triggerLoggingOnReload
			}));
			location.reload(true);
			log('VerifySessionTimeOut() - options, timeout', options, true);
			return true;
		} else if (timeDif > this.timeOut) {
			location.reload(true);
			log('VerifySessionTimeOut() - timeout', true);
			return true;
		}

		this.time = Date.now();
		log('VerifySessionTimeOut() - timeout', false);
		return false;
	}
}

export let logService = new LogService();
